angular.module('tf.controllers')

    .controller('AccountFarmersController', ['$scope', '$state', 'FarmService','NotificationService', 'Session',
        function ($scope, $state, FarmService, NotificationService, Session){

            $scope.session = Session;

            var hasFarmersQuota = false;
            function checkFarmersQuota(){
                $scope.isLoadingFramersQuota = true;
                FarmService.checkAvailableFarmersQuota().then(function (res) {
                    $('.account-header-menu .account-header-buttons .account-header-button i.fa-spin').removeClass('fa-spin');
                    $scope.isLoadingFramersQuota = false;
                    hasFarmersQuota = res.data;
                });
            }

            function initFarm(){
                checkFarmersQuota();
                $scope.loader({overlay : false});
                FarmService.getFarm().then(function(farm){
                    $scope.farm = farm;
                    FarmService.getClusters().then(function(clusters){
                        $scope.farm.clusters = clusters;
                        $scope.loader(false);
                    });


                });
            }

            if($state.current.name.indexOf('clusters') > -1){
                $scope.activeTab = 1;
            } else {
                $scope.activeTab = 0;
            }

            $scope.farmHasFarmersQuota = function () {
               return hasFarmersQuota;
            };

            $scope.goToUpgrade = function () {
                FarmService.goToUpgrade('To add more farmers contact', {initiator:'upgrade to add farmers - farmers settings'});
            };

            $scope.addFarmer = function(){
                NotificationService.confirm("Add New Farmer", "Are you sure?", function(){
                    FarmService.addFarmer().then(function(){
                        initFarm();
                    });
                });
            };
            $scope.deleteFarmer = function(farmer){
                NotificationService.confirm("Delete Farmer", "Are you sure?", function(){
                    FarmService.deleteFarmer(farmer).then(function(){
                        initFarm();
                    });
                });
            };
            $scope.saveFarmer = function(farmer){
                NotificationService.confirm("Save Farmer", "Are you sure?", function(){
                    FarmService.updateFarmer(farmer).then(function(){
                        initFarm();
                    });
                });
            };
            $scope.disconnectFarmer = function(farmer){
                NotificationService.confirm("Disconnect Farm", "Are you sure?", function(){
                    FarmService.disconnectFarmer(farmer).then(function(){
                        initFarm();
                    });
                });
            };

            $scope.deleteCluster = function(cluster){
                NotificationService.confirm("Delete Cluster", "Are you sure?", function(){
                    FarmService.deleteCluster(cluster).then(function(){
                        initFarm();
                    });
                });
            };

            initFarm();

            $scope.openFarmerSettings= function(farmer){
                FarmService.openFarmerSettings(farmer, function(){
                    $state.go('app.account.farmers');
                    initFarm();
                });
            };
            $scope.openFarmerClusterSettings= function(cluster){
                FarmService.openFarmerClusterSettings(cluster, function(){
                    $state.go('app.account.clusters');
                    initFarm();
                });
            };

            $scope.updateFarmer = function(farmer){
                FarmService.updateFarmerVersion(farmer);
            };

        }]);